(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cabot-product-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cabot-product-options')) {
  customElements.define('cabot-product-options', class extends HTMLElement {
    connectedCallback() {
      if(this.initialized)return;this.initialized=true;
      this.form=document.getElementById(this.dataset.form);
      this.quantity=this.form.querySelector('[name="contact[Quantity]"]');
      this.variant=JSON.parse(this.querySelector('[data-initial]').textContent);
      this.quantity.type='number';this.quantity.min='1';this.quantity.step='1';this.quantity.required=true;
      if(!this.quantity.value)this.quantity.value='1';
      this.variants=JSON.parse(this.querySelector('[data-variants]').textContent);
      const names=JSON.parse(this.querySelector('[data-option-names]').textContent);
      this.selected=[...this.variant.options];
      names.forEach((name,index)=>{
        if(names.length===1&&this.variants.length===1&&this.variant.title==='Default Title')return;
        const group=document.createElement('fieldset');group.className='cabot-choices';
        const legend=document.createElement('legend');legend.textContent=name;group.append(legend);
        [...new Set(this.variants.map(v=>v.options[index]))].forEach(value=>{
          const label=document.createElement('label'),input=document.createElement('input'),text=document.createElement('span');
          input.type='radio';input.name=this.dataset.form+'-option-'+index;input.value=value;input.checked=this.selected[index]===value;
          text.textContent=value;label.append(input,text);group.append(label);
          input.addEventListener('change',()=>{this.selected[index]=value;this.variant=this.variants.find(v=>v.options.every((option,i)=>option===this.selected[i]));this.update();});
        });this.querySelector('[data-option-buttons]').append(group);
      });
      this.closest('product-info')?.classList.add('cabot-single-selector');
      this.onQuantity=()=>this.update();this.quantity.addEventListener('input',this.onQuantity);
      this.querySelectorAll('[data-decoration]').forEach(control=>control.addEventListener('change',()=>{
        const logo=this.querySelector('[data-decoration]:checked').value==='Add my logo';
        this.querySelector('[data-logo]').hidden=!logo;
        this.querySelector('[data-artwork-link]').disabled=!logo;
      }));
      this.querySelector('[data-artwork-link]').disabled=true;
      this.querySelector('[data-logo-file]').addEventListener('change',e=>{
        if(this.previewURL)URL.revokeObjectURL(this.previewURL);
        const file=e.target.files[0],image=this.querySelector('[data-logo-image]');image.hidden=true;
        if(!file)return;
        if(!['image/png','image/jpeg'].includes(file.type)||file.size>5*1024*1024){e.target.value='';this.querySelector('[data-logo-status]').textContent='Choose a PNG or JPEG no larger than 5 MB.';return;}
        this.previewURL=URL.createObjectURL(file);image.src=this.previewURL;image.hidden=false;
        this.querySelector('[data-logo-status]').textContent='Preview only. Send this artwork using an accessible link above or by email.';
      });
      this.update();
    }
    disconnectedCallback(){this.unsubscribe?.();this.quantity?.removeEventListener('input',this.onQuantity);if(this.previewURL)URL.revokeObjectURL(this.previewURL);}
    update(){
      const q=Number(this.quantity.value),v=this.variant,valid=v&&Number.isInteger(q)&&q>=1;
      const money=new Intl.NumberFormat(document.documentElement.lang||'en-CA',{style:'currency',currency:this.dataset.currency});
      this.querySelector('[data-selection]').textContent=v?v.title:'Select an available combination';
      this.querySelector('[data-variant-title]').value=v?v.title:'';this.querySelector('[data-variant-id]').value=v?v.id:'';
      this.querySelector('[data-supplier-sku]').value=v?v.sku:'';
      const sku=this.form.querySelector('[name="contact[SKU]"]');if(sku)sku.value=v?v.sku:'';
      const section=this.closest('product-info');
      if(section&&v){
        const price=section.querySelector('[id^="price-"]');
        if(price){price.querySelectorAll('.price-item--regular,.price-item--sale').forEach(el=>el.textContent=money.format(v.price/100));price.querySelector('.price')?.classList.remove('price--on-sale','price--sold-out');}
        const skuDisplay=section.querySelector('[id^="Sku-"]');if(skuDisplay){const text=skuDisplay.querySelector('span:last-child');if(text)text.textContent=v.sku||'';}
      }
      const total=valid?money.format(v.price*q/100):'Enter a whole quantity of at least 1';
      this.querySelector('[data-subtotal]').textContent=total;this.querySelector('[data-total-field]').value=valid?total:'';
      this.form.querySelector('[type="submit"]').disabled=!valid;
      this.querySelector('[data-status]').textContent=valid?'Final availability, decoration and delivery charges will be confirmed.':'Choose a valid variant and quantity.';
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
